export const COMPANYFULLNAME = "Richview Engineering Inc.";
export const TIPSTAG_SUCCESS = "success";
export const TIPSTAG_INFO = "info";
export const TIPSTAG_WARNING = "warning";
export const TIPSTAG_ERROR = "error";


export const WEEKDAYS = [
    'weekDays.sunday', 
    'weekDays.monday', 
    'weekDays.tuesday', 
    'weekDays.wednesday', 
    'weekDays.thursday', 
    'weekDays.friday', 
    'weekDays.saturday'
];

export const MONTHS = [
    'Jan', 'Feb', 'Mar',
    'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep',
    'Oct', 'Nov', 'Dec'
];